// extracted by mini-css-extract-plugin
export default {"downloadIcon":"DownloadIcon_downloadIcon__7VaRN"};